import api from "../../../api/aiAPI";

const chat = async (payload = {}) => {
    try {
        const res = await api.post("/chat", payload);
        const responseData = res?.data;

        if (responseData?.error) {
            throw {
                msg: responseData.msg || responseData.message || "Unable to process chat request",
                error: responseData
            };
        }

        return responseData;
    } catch (error) {
        const errorMessage =
            error?.response?.data?.msg ||
            error?.response?.data?.message ||
            error?.msg ||
            error?.message ||
            "Something Went Wrong";

        throw {
            msg: errorMessage,
            error
        };
    }
};

const assistantServices = {
    chat
};

export default assistantServices;